import $ from 'jquery';

export default class Footer {
    constructor() {
        this.$submenuToggles = $('#menu-footer-menu .parent-container button');

        this.bind();
    }

    bind() {
        this.$submenuToggles.on("click", this.toggleSubmenu.bind(this));
    }

    toggleSubmenu(e) {
        const $toggle = $(e.currentTarget);
        const $menuItem = $toggle.closest('.menu-item');
        const $subMenu = $menuItem.find('> .sub-menu');
        const expanded = $toggle.attr('aria-expanded') === 'true';

        // Accordion behavior: close any other open submenus at the same level
        if (!expanded) {
            $menuItem.siblings('.menu-item')
                .find('.parent-container button[aria-expanded="true"]')
                .each((_, el) => {
                    const $otherToggle = $(el);
                    $otherToggle.attr('aria-expanded', 'false');
                    $otherToggle.closest('.menu-item')
                        .find('> .sub-menu')
                        .removeClass('is-open')
                        .slideUp(300);
                });
        }

        $toggle.attr('aria-expanded', !expanded);
        $subMenu.toggleClass('is-open').slideToggle(300);
    }
}
